

export const countryCode: Array<any> = [
    {
        "code":86,
        "cn":"中国",
        "en":"China",
        "py":"ZHONG GUO DA LU",
        "country":"CN",
        "open":1,
        "countryId":"1",
        "heat":100
    },
    {
        "code":852,
        "cn":"中国香港",
        "en":"Hong Kong",
        "py":"ZHONG GUO XIANG GANG",
        "country":"HK",
        "open":1,
        "provinceId":"32",
        "heat":99
    },
    {
        "code":853,
        "cn":"中国澳门",
        "en":"Macao",
        "py":"ZHONG GUO AO MEN",
        "country":"MO",
        "open":1,
        "provinceId":"33",
        "heat":98
    },
    {
        "code":886,
        "cn":"中国台湾",
        "en":"Taiwan",
        "py":"ZHONG GUO TAI WAN",
        "country":"TW",
        "open":1,
        "provinceId":"53",
        "heat":97
    },
    {
        "code":1,
        "cn":"加拿大",
        "en":"Canada",
        "py":"JIA NA DA",
        "country":"CA",
        "open":1,
        "countryId":"47",
        "heat":96
    },
    {
        "code":1,
        "cn":"美国",
        "en":"United States",
        "py":"MEI GUO",
        "country":"US",
        "open":1,
        "countryId":"66",
        "heat":96
    },
    {
        "code":7,
        "cn":"俄罗斯",
        "en":"Russia",
        "py":"E LUO SI",
        "country":"RU",
        "open":1,
        "countryId":"30",
        "heat":94
    },
    {
        "code":33,
        "cn":"法国",
        "en":"France",
        "py":"FA GUO",
        "country":"FR",
        "open":1,
        "countryId":"31",
        "heat":93
    },
    {
        "code":39,
        "cn":"意大利",
        "en":"Italy",
        "py":"YI DA LI ",
        "country":"IT",
        "open":1,
        "countryId":"106",
        "heat":92
    },
    {
        "code":44,
        "cn":"英国",
        "en":"United Kingdom",
        "py":"YING GUO",
        "country":"GB",
        "open":1,
        "countryId":"109",
        "heat":91
    },
    {
        "code":49,
        "cn":"德国",
        "en":"Germany",
        "py":"DE GUO",
        "country":"DE",
        "open":1,
        "countryId":"28",
        "heat":90
    },
    {
        "code":60,
        "cn":"马来西亚",
        "en":"Malaysia",
        "py":"MA LAI XI YA",
        "country":"MY",
        "open":1,
        "countryId":"2",
        "heat":89
    },
    {
        "code":61,
        "cn":"澳大利亚",
        "en":"Australia",
        "py":"AO DA LI YA",
        "country":"AU",
        "open":1,
        "countryId":"15",
        "heat":88
    },
    {
        "code":62,
        "cn":"印度尼西亚",
        "en":"Indonesia",
        "py":"YIN DU NI XI YA",
        "country":"ID",
        "open":1,
        "countryId":"108",
        "heat":87
    },
    {
        "code":63,
        "cn":"菲律宾",
        "en":"Philippines",
        "py":"FEI LV BIN",
        "country":"PH",
        "open":1,
        "countryId":"32",
        "heat":86
    },
    {
        "code":64,
        "cn":"新西兰",
        "en":"New Zealand",
        "py":"XIN XI LAN",
        "country":"NZ",
        "open":1,
        "countryId":"98",
        "heat":85
    },
    {
        "code":65,
        "cn":"新加坡",
        "en":"Singapore",
        "py":"XIN JIA PO",
        "country":"SG",
        "open":1,
        "countryId":"3",
        "heat":84
    },
    {
        "code":66,
        "cn":"泰国",
        "en":"Thailand",
        "py":"TAI GUO",
        "country":"TH",
        "open":1,
        "countryId":"4",
        "heat":83
    },
    {
        "code":81,
        "cn":"日本",
        "en":"Japan",
        "py":"RI BEN",
        "country":"JP",
        "open":1,
        "countryId":"78",
        "heat":82
    },
    {
        "code":82,
        "cn":"韩国",
        "en":"South Korea",
        "py":"HAN GUO",
        "country":"KR",
        "open":1,
        "countryId":"42",
        "heat":81
    },
    {
        "code":84,
        "cn":"越南",
        "en":"Viet Nam",
        "py":"YUE NAN",
        "country":"VN",
        "open":1,
        "countryId":"111",
        "heat":80
    },
    {
        "code":91,
        "cn":"印度",
        "en":"India",
        "py":"YIN DU",
        "country":"IN",
        "open":1,
        "countryId":"107",
        "heat":79
    },
    {
        "code":855,
        "cn":"柬埔寨",
        "en":"Cambodia",
        "py":"JIAN PU ZHAI",
        "country":"KH",
        "open":1,
        "countryId":"50",
        "heat":78
    },
    {
        "code":355,
        "cn":"阿尔巴尼亚",
        "en":"Albania",
        "py":"A ER BA NI YA",
        "country":"AL",
        "open":1,
        "countryId":"5",
        "heat":0
    },
    {
        "code":213,
        "cn":"阿尔及利亚",
        "en":"Algeria",
        "py":"A ER JI LI YA",
        "country":"DZ",
        "open":1,
        "countryId":"6",
        "heat":0
    },
    {
        "code":93,
        "cn":"阿富汗",
        "en":"Afghanistan",
        "py":"A FU HAN",
        "country":"AF",
        "open":1,
        "countryId":"7",
        "heat":0
    },
    {
        "code":54,
        "cn":"阿根廷",
        "en":"Argentina",
        "py":"A GEN TING",
        "country":"AR",
        "open":1,
        "countryId":"8",
        "heat":0
    },
    {
        "code":971,
        "cn":"阿联酋",
        "en":"United Arab Emirates",
        "py":"A LA BO LIAN HE QIU ZHANG GUO",
        "country":"AE",
        "open":1,
        "countryId":"9",
        "heat":0
    },
    {
        "code":297,
        "cn":"阿鲁巴",
        "en":"Aruba",
        "py":"A LU BA DAO",
        "country":"AW",
        "open":1,
        "countryId":"171",
        "heat":0
    },
    {
        "code":968,
        "cn":"阿曼",
        "en":"Oman",
        "py":"A MAN",
        "country":"OM",
        "open":1,
        "countryId":"150",
        "heat":0
    },
    {
        "code":994,
        "cn":"阿塞拜疆",
        "en":"Azerbaijan",
        "py":"A SAI BAI JIANG",
        "country":"AZ",
        "open":1,
        "countryId":"145",
        "heat":0
    },
    {
        "code":247,
        "cn":"阿森松",
        "en":"Ascension",
        "py":"A SEN SONG",
        "country":"",
        "open":1,
        "heat":0
    },
    {
        "code":20,
        "cn":"埃及",
        "en":"Egypt",
        "py":"AI JI",
        "country":"EG",
        "open":1,
        "countryId":"10",
        "heat":0
    },
    {
        "code":251,
        "cn":"埃塞俄比亚",
        "en":"Ethiopia",
        "py":"AI SAI E BI YA",
        "country":"ET",
        "open":1,
        "countryId":"11",
        "heat":0
    },
    {
        "code":353,
        "cn":"爱尔兰",
        "en":"Ireland",
        "py":"AI ER LAN",
        "country":"IE",
        "open":1,
        "countryId":"12",
        "heat":0
    },
    {
        "code":372,
        "cn":"爱沙尼亚",
        "en":"Estonia",
        "py":"AI SHA NI YA",
        "country":"EE",
        "open":1,
        "countryId":"166",
        "heat":0
    },
    {
        "code":376,
        "cn":"安道尔",
        "en":"Andorra",
        "py":"AN DAO ER GONG HE GUO",
        "country":"AD",
        "open":1,
        "countryId":"200",
        "heat":0
    },
    {
        "code":244,
        "cn":"安哥拉",
        "en":"Angola",
        "py":"AN GE LA",
        "country":"AO",
        "open":1,
        "countryId":"13",
        "heat":0
    },
    {
        "code":1264,
        "cn":"安圭拉",
        "en":"Anguilla",
        "py":"AN GUI LA DAO",
        "country":"AI",
        "open":1,
        "countryId":"275",
        "heat":0
    },
    {
        "code":1268,
        "cn":"安提瓜和巴布达",
        "en":"Antigua and barbuda",
        "py":"AN TI GUA HE BA BU DA",
        "country":"AG",
        "open":1,
        "countryId":"201",
        "heat":0
    },
    {
        "code":43,
        "cn":"奥地利",
        "en":"Austria",
        "py":"AO DI LI",
        "country":"AT",
        "open":1,
        "countryId":"14",
        "heat":0
    },
    {
        "code":1246,
        "cn":"巴巴多斯",
        "en":"Barbados",
        "py":"BA BA DUO SI",
        "country":"BB",
        "open":1,
        "countryId":"202",
        "heat":0
    },
    {
        "code":675,
        "cn":"巴布亚新几内亚",
        "en":"Papua New Guinea",
        "py":"BA BU YA XIN JI NEI YA",
        "country":"PG",
        "open":1,
        "countryId":"153",
        "heat":0
    },
    {
        "code":1242,
        "cn":"巴哈马",
        "en":"Bahamas",
        "py":"BA  HA MA",
        "country":"BS",
        "open":1,
        "countryId":"185",
        "heat":0
    },
    {
        "code":92,
        "cn":"巴基斯坦",
        "en":"Pakistan",
        "py":"BA JI SI TAN",
        "country":"PK",
        "open":1,
        "countryId":"17",
        "heat":0
    },
    {
        "code":595,
        "cn":"巴拉圭",
        "en":"Paraguay",
        "py":"BA LA GUI",
        "country":"PY",
        "open":1,
        "countryId":"147",
        "heat":0
    },
    {
        "code":970,
        "cn":"巴勒斯坦",
        "en":"Palestine",
        "py":"BA LE SI TAN",
        "country":"PS",
        "open":1,
        "countryId":"205",
        "heat":0
    },
    {
        "code":973,
        "cn":"巴林",
        "en":"Bahrain",
        "py":"BA LIN",
        "country":"BH",
        "open":1,
        "countryId":"118",
        "heat":0
    },
    {
        "code":507,
        "cn":"巴拿马",
        "en":"Panama",
        "py":"BA NA MA",
        "country":"PA",
        "open":1,
        "countryId":"18",
        "heat":0
    },
    {
        "code":55,
        "cn":"巴西",
        "en":"Brazil",
        "py":"BA XI",
        "country":"BR",
        "open":1,
        "countryId":"19",
        "heat":0
    },
    {
        "code":375,
        "cn":"白俄罗斯",
        "en":"Belarus",
        "py":"BAI E LUO SI",
        "country":"BY",
        "open":1,
        "countryId":"151",
        "heat":0
    },
    {
        "code":1441,
        "cn":"百慕大",
        "en":"Bermuda",
        "py":"BAI MU DA QUN DAO",
        "country":"BM",
        "open":1,
        "countryId":"207",
        "heat":0
    },
    {
        "code":359,
        "cn":"保加利亚",
        "en":"Bulgaria",
        "py":"BAO JIA LI YA",
        "country":"BG",
        "open":1,
        "countryId":"20",
        "heat":0
    },
    {
        "code":229,
        "cn":"贝宁",
        "en":"Benin",
        "py":"BEI NING",
        "country":"BJ",
        "open":1,
        "countryId":"178",
        "heat":0
    },
    {
        "code":32,
        "cn":"比利时",
        "en":"Belgium",
        "py":"BI LI SHI",
        "country":"BE",
        "open":1,
        "countryId":"21",
        "heat":0
    },
    {
        "code":354,
        "cn":"冰岛",
        "en":"Iceland",
        "py":"BING DAO ",
        "country":"IS",
        "open":1,
        "countryId":"22",
        "heat":0
    },
    {
        "code":1787,
        "cn":"波多黎各",
        "en":"Puerto Rico",
        "py":"BO DUO LI GE",
        "country":"PR",
        "open":1,
        "countryId":"208",
        "heat":0
    },
    {
        "code":48,
        "cn":"波兰",
        "en":"Poland",
        "py":"BO LAN",
        "country":"PL",
        "open":1,
        "countryId":"23",
        "heat":0
    },
    {
        "code":387,
        "cn":"波斯尼亚和黑塞哥维那",
        "en":"Bosnia and Herzegovina",
        "py":"BO SI NI YA HE HEI SAI GE WEI NA",
        "country":"BA",
        "open":1,
        "heat":0
    },
    {
        "code":591,
        "cn":"玻利维亚",
        "en":"Bolivia",
        "py":"BO LI WEI YA",
        "country":"BO",
        "open":1,
        "countryId":"24",
        "heat":0
    },
    {
        "code":501,
        "cn":"伯利兹",
        "en":"Belize",
        "py":"BO LI ZI",
        "country":"BZ",
        "open":1,
        "countryId":"210",
        "heat":0
    },
    {
        "code":267,
        "cn":"博茨瓦纳",
        "en":"Botswana",
        "py":"BO CI WA NA",
        "country":"BW",
        "open":1,
        "countryId":"152",
        "heat":0
    },
    {
        "code":975,
        "cn":"不丹",
        "en":"Bhutan",
        "py":"BU DAN",
        "country":"BT",
        "open":1,
        "countryId":"212",
        "heat":0
    },
    {
        "code":226,
        "cn":"布基纳法索",
        "en":"Burkina Faso",
        "py":"BU JI NA FA SUO",
        "country":"BF",
        "open":1,
        "countryId":"213",
        "heat":0
    },
    {
        "code":257,
        "cn":"布隆迪",
        "en":"Burundi",
        "py":"BU LONG DI",
        "country":"BI",
        "open":1,
        "countryId":"25",
        "heat":0
    },
    {
        "code":850,
        "cn":"朝鲜",
        "en":"Korea, Democratic Pe",
        "py":"CHAO XIAN",
        "country":"KP",
        "open":1,
        "countryId":"26",
        "heat":0
    },
    {
        "code":240,
        "cn":"赤道几内亚",
        "en":"Equatorial Guinea",
        "py":"CHI DAO JI NEI YA",
        "country":"GQ",
        "open":1,
        "countryId":"214",
        "heat":0
    },
    {
        "code":45,
        "cn":"丹麦",
        "en":"Denmark",
        "py":"DAN MAI",
        "country":"DK",
        "open":1,
        "countryId":"27",
        "heat":0
    },
    {
        "code":670,
        "cn":"东帝汶",
        "en":"East Timor",
        "py":"DONG DI WEN",
        "country":"TL",
        "open":1,
        "countryId":"215",
        "heat":0
    },
    {
        "code":684,
        "cn":"东萨摩亚(美)",
        "en":"Samoa Eastern",
        "py":"DONG SA MO YA",
        "country":"",
        "open":0,
        "heat":0
    },
    {
        "code":228,
        "cn":"多哥",
        "en":"Togo",
        "py":"DUO GE",
        "country":"TG",
        "open":1,
        "countryId":"216",
        "heat":0
    },
    {
        "code":1809,
        "cn":"多米尼加共和国",
        "en":"Dominican Republic",
        "py":"DUO MI NI JIA GONG HE GUO",
        "country":"DO",
        "open":1,
        "countryId":"276",
        "heat":0
    },
    {
        "code":593,
        "cn":"厄瓜多尔",
        "en":"Ecuador",
        "py":"E GUA DUO ER",
        "country":"EC",
        "open":1,
        "countryId":"155",
        "heat":0
    },
    {
        "code":291,
        "cn":"厄立特里亚",
        "en":"Eritrea",
        "py":"E LI TE LI YA",
        "country":"ER",
        "open":1,
        "countryId":"184",
        "heat":0
    },
    {
        "code":298,
        "cn":"法罗群岛",
        "en":"Faroe Islands",
        "py":"FA LUO QUN DAO",
        "country":"FO",
        "open":1,
        "countryId":"283",
        "heat":0
    },
    {
        "code":689,
        "cn":"法属波利尼西亚",
        "en":"French Polynesia",
        "py":"FA SHU BO LI NI XI YA",
        "country":"PF",
        "open":1,
        "countryId":"264",
        "heat":0
    },
    {
        "code":594,
        "cn":"法属圭亚那",
        "en":"French Guiana",
        "py":"FA SHU GUI YA NA",
        "country":"GF",
        "open":1,
        "heat":0
    },
    {
        "code":379,
        "cn":"梵蒂冈",
        "en":"Vatican",
        "py":"FAN DI GANG",
        "country":"VA",
        "open":1,
        "countryId":"167",
        "heat":0
    },
    {
        "code":679,
        "cn":"斐济",
        "en":"Fiji",
        "py":"FEI JI",
        "country":"FJ",
        "open":1,
        "countryId":"33",
        "heat":0
    },
    {
        "code":358,
        "cn":"芬兰",
        "en":"Finland",
        "py":"FEN LAN",
        "country":"FI",
        "open":1,
        "countryId":"34",
        "heat":0
    },
    {
        "code":238,
        "cn":"佛得角",
        "en":"Cape Verde",
        "py":"FU DE JIAO",
        "country":"CV",
        "open":1,
        "countryId":"219",
        "heat":0
    },
    {
        "code":500,
        "cn":"福克兰群岛",
        "en":"Falkland Islands",
        "py":"FU LAN KE QUN DAO",
        "country":"FK",
        "open":1,
        "countryId":"277",
        "heat":0
    },
    {
        "code":220,
        "cn":"冈比亚",
        "en":"Gambia",
        "py":"GANG BI YA",
        "country":"GM",
        "open":1,
        "countryId":"35",
        "heat":0
    },
    {
        "code":242,
        "cn":"刚果共和国",
        "en":"Congo",
        "py":"GANG GUO",
        "country":"CG",
        "open":1,
        "countryId":"271",
        "heat":0
    },
    {
        "code":57,
        "cn":"哥伦比亚",
        "en":"Colombia",
        "py":"GE LUN BI YA",
        "country":"CO",
        "open":1,
        "countryId":"37",
        "heat":0
    },
    {
        "code":506,
        "cn":"哥斯达黎加",
        "en":"Costa Rica",
        "py":"GE SI DA LI JIA",
        "country":"CR",
        "open":1,
        "countryId":"38",
        "heat":0
    },
    {
        "code":1473,
        "cn":"格林纳达",
        "en":"Grenada",
        "py":"GE LIN NA DA",
        "country":"GD",
        "open":1,
        "countryId":"220",
        "heat":0
    },
    {
        "code":299,
        "cn":"格陵兰",
        "en":"Greenland",
        "py":"GE LIN LAN DAO",
        "country":"GL",
        "open":1,
        "countryId":"268",
        "heat":0
    },
    {
        "code":995,
        "cn":"格鲁吉亚",
        "en":"Georgia",
        "py":"GE LU JI YA ",
        "country":"GE",
        "open":1,
        "countryId":"180",
        "heat":0
    },
    {
        "code":53,
        "cn":"古巴",
        "en":"Cuba",
        "py":"GU BA",
        "country":"CU",
        "open":1,
        "countryId":"39",
        "heat":0
    },
    {
        "code":1671,
        "cn":"关岛",
        "en":"Guam",
        "py":"GUAN DAO",
        "country":"GU",
        "open":1,
        "countryId":"192",
        "heat":0
    },
    {
        "code":592,
        "cn":"圭亚那",
        "en":"Guyana",
        "py":"GUI YA NA ",
        "country":"GY",
        "open":1,
        "countryId":"40",
        "heat":0
    },
    {
        "code":509,
        "cn":"海地",
        "en":"Haiti",
        "py":"HAI DI",
        "country":"HT",
        "open":1,
        "countryId":"41",
        "heat":0
    },
    {
        "code":31,
        "cn":"荷兰",
        "en":"Netherlands",
        "py":"HE LAN",
        "country":"NL",
        "open":1,
        "countryId":"43",
        "heat":0
    },
    {
        "code":599,
        "cn":"荷属安第列斯",
        "en":"Netherlands Antilles",
        "py":"HE SHU AN DE LIE SI",
        "country":"",
        "open":1,
        "countryId":"259",
        "heat":0
    },
    {
        "code":382,
        "cn":"黑山",
        "en":"Montenegro",
        "py":"HEI SHAN GONG HE GUO",
        "country":"ME",
        "open":1,
        "countryId":"257",
        "heat":0
    },
    {
        "code":504,
        "cn":"洪都拉斯",
        "en":"Honduras",
        "py":"HONG DU LA SI",
        "country":"HN",
        "open":1,
        "countryId":"44",
        "heat":0
    },
    {
        "code":686,
        "cn":"基里巴斯",
        "en":"Kiribati",
        "py":"JI LI BA SI",
        "country":"KI",
        "open":1,
        "countryId":"221",
        "heat":0
    },
    {
        "code":253,
        "cn":"吉布提",
        "en":"Djibouti",
        "py":"JI BU TI",
        "country":"DJ",
        "open":1,
        "countryId":"45",
        "heat":0
    },
    {
        "code":996,
        "cn":"吉尔吉斯斯坦",
        "en":"Kirgizstan",
        "py":"JI ER JI SI SI TAN",
        "country":"KG",
        "open":1,
        "countryId":"143",
        "heat":0
    },
    {
        "code":224,
        "cn":"几内亚",
        "en":"Guinea",
        "py":"JI NEI YA",
        "country":"GN",
        "open":1,
        "countryId":"46",
        "heat":0
    },
    {
        "code":245,
        "cn":"几内亚比绍",
        "en":"Guinea-bissau",
        "py":"JI NEI YA BI SHAO",
        "country":"GW",
        "open":1,
        "countryId":"222",
        "heat":0
    },
    {
        "code":233,
        "cn":"加纳",
        "en":"Ghana",
        "py":"JIA  NA ",
        "country":"GH",
        "open":1,
        "countryId":"48",
        "heat":0
    },
    {
        "code":241,
        "cn":"加蓬",
        "en":"Gabon",
        "py":"JIA PENG",
        "country":"GA",
        "open":1,
        "countryId":"49",
        "heat":0
    },
    {
        "code":420,
        "cn":"捷克",
        "en":"Czech",
        "py":"JIE KE",
        "country":"CZ",
        "open":1,
        "countryId":"162",
        "heat":0
    },
    {
        "code":263,
        "cn":"津巴布韦",
        "en":"Zimbabwe",
        "py":"JIN BA BU WEI",
        "country":"ZW",
        "open":1,
        "countryId":"51",
        "heat":0
    },
    {
        "code":237,
        "cn":"喀麦隆",
        "en":"Cameroon",
        "py":"KA MAI LONG",
        "country":"CM",
        "open":1,
        "countryId":"52",
        "heat":0
    },
    {
        "code":974,
        "cn":"卡塔尔",
        "en":"Qatar",
        "py":"KA TA ER",
        "country":"QA",
        "open":1,
        "countryId":"163",
        "heat":0
    },
    {
        "code":1345,
        "cn":"开曼群岛",
        "en":"Cayman Islands",
        "py":"KAI MAN QUN DAO",
        "country":"KY",
        "open":1,
        "countryId":"223",
        "heat":0
    },
    {
        "code":269,
        "cn":"科摩罗",
        "en":"Comoros",
        "py":"KE MO LUO",
        "country":"KM",
        "open":1,
        "countryId":"224",
        "heat":0
    },
    {
        "code":383,
        "cn":"科索沃",
        "en":"Kosovo",
        "py":"KE SUO WO",
        "country":"YK",
        "open":0,
        "countryId":"293",
        "heat":0
    },
    {
        "code":225,
        "cn":"科特迪瓦",
        "en":"Coted Ivoire",
        "py":"KE TE DI WA",
        "country":"CI",
        "open":1,
        "countryId":"179",
        "heat":0
    },
    {
        "code":965,
        "cn":"科威特",
        "en":"Kuwait",
        "py":"KE WEI TE",
        "country":"KW",
        "open":1,
        "countryId":"53",
        "heat":0
    },
    {
        "code":385,
        "cn":"克罗地亚",
        "en":"Croatia",
        "py":"KE LUO DI YA",
        "country":"HR",
        "open":1,
        "countryId":"164",
        "heat":0
    },
    {
        "code":254,
        "cn":"肯尼亚",
        "en":"Kenya",
        "py":"KEN NI YA",
        "country":"KE",
        "open":1,
        "countryId":"54",
        "heat":0
    },
    {
        "code":682,
        "cn":"库克群岛",
        "en":"Cook Islands",
        "py":"KU KE QUN DAO",
        "country":"CK",
        "open":1,
        "countryId":"191",
        "heat":0
    },
    {
        "code":371,
        "cn":"拉脱维亚",
        "en":"Latvia",
        "py":"LA TUO WEI YA",
        "country":"LV",
        "open":1,
        "countryId":"225",
        "heat":0
    },
    {
        "code":266,
        "cn":"莱索托",
        "en":"Lesotho",
        "py":"LAI SUO TUO",
        "country":"LS",
        "open":1,
        "countryId":"187",
        "heat":0
    },
    {
        "code":856,
        "cn":"老挝",
        "en":"Lao",
        "py":"LAO WO",
        "country":"LA",
        "open":1,
        "countryId":"55",
        "heat":0
    },
    {
        "code":961,
        "cn":"黎巴嫩",
        "en":"Lebanon",
        "py":"LI MA NEN",
        "country":"LB",
        "open":1,
        "countryId":"56",
        "heat":0
    },
    {
        "code":370,
        "cn":"立陶宛",
        "en":"Lithuania",
        "py":"LI TAO WAN",
        "country":"LT",
        "open":1,
        "countryId":"57",
        "heat":0
    },
    {
        "code":231,
        "cn":"利比里亚",
        "en":"Liberia",
        "py":"LI BI LI YA",
        "country":"LR",
        "open":1,
        "countryId":"59",
        "heat":0
    },
    {
        "code":218,
        "cn":"利比亚",
        "en":"Libya",
        "py":"LI BI YA",
        "country":"LY",
        "open":1,
        "countryId":"60",
        "heat":0
    },
    {
        "code":423,
        "cn":"列支敦士登",
        "en":"Liechtenstein",
        "py":"LIE ZHI DUN SHI DENG",
        "country":"LI",
        "open":1,
        "countryId":"226",
        "heat":0
    },
    {
        "code":262,
        "cn":"留尼汪（法属）",
        "en":"Reunion",
        "py":"NI LIU WANG",
        "country":"RE",
        "open":1,
        "countryId":"269",
        "heat":0
    },
    {
        "code":352,
        "cn":"卢森堡",
        "en":"Luxembourg",
        "py":"LU SEN BAO",
        "country":"LU",
        "open":1,
        "countryId":"61",
        "heat":0
    },
    {
        "code":250,
        "cn":"卢旺达",
        "en":"Rwanda",
        "py":"LU WANG DA",
        "country":"RW",
        "open":1,
        "countryId":"62",
        "heat":0
    },
    {
        "code":40,
        "cn":"罗马尼亚",
        "en":"Romania",
        "py":"LUO MA NI YA",
        "country":"RO",
        "open":1,
        "countryId":"63",
        "heat":0
    },
    {
        "code":261,
        "cn":"马达加斯加",
        "en":"Madagascar",
        "py":"MA DA JIA SI JIA",
        "country":"MG",
        "open":1,
        "countryId":"227",
        "heat":0
    },
    {
        "code":960,
        "cn":"马尔代夫",
        "en":"Maldives",
        "py":"MA ER DAI FU",
        "country":"MV",
        "open":1,
        "countryId":"146",
        "heat":0
    },
    {
        "code":356,
        "cn":"马耳他",
        "en":"Malta",
        "py":"MA ER TA",
        "country":"MT",
        "open":1,
        "countryId":"161",
        "heat":0
    },
    {
        "code":265,
        "cn":"马拉维",
        "en":"Malawi",
        "py":"MA LA WEI",
        "country":"MW",
        "open":1,
        "countryId":"186",
        "heat":0
    },
    {
        "code":223,
        "cn":"马里",
        "en":"Mali",
        "py":"MA LI",
        "country":"ML",
        "open":1,
        "countryId":"228",
        "heat":0
    },
    {
        "code":1670,
        "cn":"马里亚那群岛",
        "en":"Mariana Is",
        "py":"MA LI YA NA QUN DAO",
        "country":"MP",
        "open":1,
        "heat":0
    },
    {
        "code":389,
        "cn":"马其顿共和国",
        "en":"Macedonia",
        "py":"MA QI DUN GONG HE GUO",
        "country":"MK",
        "open":1,
        "countryId":"197",
        "heat":0
    },
    {
        "code":692,
        "cn":"马绍尔群岛",
        "en":"Marshall Islands",
        "py":"MA SHAO ER QUN DAO",
        "country":"MH",
        "open":1,
        "countryId":"229",
        "heat":0
    },
    {
        "code":596,
        "cn":"马提尼克",
        "en":"Martinique",
        "py":"MA TI NI KE",
        "country":"MQ",
        "open":1,
        "countryId":"279",
        "heat":0
    },
    {
        "code":262,
        "cn":"马约特",
        "en":"Mayotte",
        "py":"MA YUE TE DAO",
        "country":"YT",
        "open":1,
        "countryId":"270",
        "heat":0
    },
    {
        "code":230,
        "cn":"毛里求斯",
        "en":"Mauritius",
        "py":"MAO LI QIU SI",
        "country":"MU",
        "open":1,
        "countryId":"64",
        "heat":0
    },
    {
        "code":222,
        "cn":"毛里塔尼亚",
        "en":"Mauritania",
        "py":"MAO LI TA NI YA",
        "country":"MR",
        "open":1,
        "countryId":"65",
        "heat":0
    },
    {
        "code":976,
        "cn":"蒙古",
        "en":"Mongolia",
        "py":"MENG GU",
        "country":"MN",
        "open":1,
        "countryId":"67",
        "heat":0
    },
    {
        "code":1664,
        "cn":"蒙特塞拉特岛",
        "en":"Montserrat Is",
        "py":"MENG TE SAI LA TE DAO",
        "country":"MS",
        "open":1,
        "heat":0
    },
    {
        "code":880,
        "cn":"孟加拉国",
        "en":"Bangladesh",
        "py":"MENG JIA LA GUO",
        "country":"BD",
        "open":1,
        "countryId":"68",
        "heat":0
    },
    {
        "code":51,
        "cn":"秘鲁",
        "en":"Peru",
        "py":"MI LU",
        "country":"PE",
        "open":1,
        "countryId":"69",
        "heat":0
    },
    {
        "code":691,
        "cn":"密克罗尼西亚",
        "en":"Micronesia",
        "py":"MI KE LUO NI XI YA",
        "country":"FM",
        "open":1,
        "countryId":"230",
        "heat":0
    },
    {
        "code":95,
        "cn":"缅甸",
        "en":"Myanmar",
        "py":"MIAN DIAN",
        "country":"MM",
        "open":1,
        "countryId":"70",
        "heat":0
    },
    {
        "code":373,
        "cn":"摩尔多瓦",
        "en":"Moldova",
        "py":"MO ER DUO WA",
        "country":"MD",
        "open":1,
        "countryId":"182",
        "heat":0
    },
    {
        "code":212,
        "cn":"摩洛哥",
        "en":"Morocco",
        "py":"MO LUO GE",
        "country":"MA",
        "open":1,
        "countryId":"71",
        "heat":0
    },
    {
        "code":377,
        "cn":"摩纳哥",
        "en":"Monaco",
        "py":"MO NA GE",
        "country":"MC",
        "open":1,
        "countryId":"231",
        "heat":0
    },
    {
        "code":258,
        "cn":"莫桑比克",
        "en":"Mozambique",
        "py":"MO SANG BI KE",
        "country":"MZ",
        "open":1,
        "countryId":"157",
        "heat":0
    },
    {
        "code":52,
        "cn":"墨西哥",
        "en":"Mexico",
        "py":"MO XI GE",
        "country":"MX",
        "open":1,
        "countryId":"72",
        "heat":0
    },
    {
        "code":264,
        "cn":"纳米比亚",
        "en":"Namibia",
        "py":"NA MI BI YA",
        "country":"NA",
        "open":1,
        "countryId":"159",
        "heat":0
    },
    {
        "code":27,
        "cn":"南非",
        "en":"South Africa",
        "py":"NAN FEI",
        "country":"ZA",
        "open":1,
        "countryId":"73",
        "heat":0
    },
    {
        "code":672,
        "cn":"南极",
        "en":"South Pole",
        "py":"NAN JI ZHOU",
        "country":"AQ",
        "open":1,
        "countryId":"292",
        "heat":0
    },
    {
        "code":381,
        "cn":"南斯拉夫",
        "en":"Yugoslavia",
        "py":"NAN SI LA FU",
        "country":"",
        "open":1,
        "countryId":"116",
        "heat":0
    },
    {
        "code":211,
        "cn":"南苏丹",
        "en":"SOUTH SUDAN",
        "py":"NAN SU DAN",
        "country":"SS",
        "open":1,
        "countryId":"301",
        "heat":0
    },
    {
        "code":674,
        "cn":"瑙鲁",
        "en":"Nauru",
        "py":"NAO LU",
        "country":"NR",
        "open":1,
        "countryId":"234",
        "heat":0
    },
    {
        "code":977,
        "cn":"尼泊尔",
        "en":"Nepal",
        "py":"NI BO ER",
        "country":"NP",
        "open":1,
        "countryId":"74",
        "heat":0
    },
    {
        "code":505,
        "cn":"尼加拉瓜",
        "en":"Nicaragua",
        "py":"NI JIA LA GUA",
        "country":"NI",
        "open":1,
        "countryId":"198",
        "heat":0
    },
    {
        "code":227,
        "cn":"尼日尔",
        "en":"Niger",
        "py":"NI RI ER",
        "country":"NE",
        "open":1,
        "countryId":"158",
        "heat":0
    },
    {
        "code":234,
        "cn":"尼日利亚",
        "en":"Nigeria",
        "py":"NI RI LI YA",
        "country":"NG",
        "open":1,
        "countryId":"75",
        "heat":0
    },
    {
        "code":683,
        "cn":"纽埃（新西兰属）",
        "en":"Niue",
        "py":"NIU AI DAO",
        "country":"NU",
        "open":1,
        "countryId":"236",
        "heat":0
    },
    {
        "code":47,
        "cn":"挪威",
        "en":"Norway",
        "py":"NUO WEI",
        "country":"NO",
        "open":1,
        "countryId":"76",
        "heat":0
    },
    {
        "code":680,
        "cn":"帕劳群岛",
        "en":"Palau",
        "py":"PA LAO",
        "country":"PW",
        "open":1,
        "countryId":"237",
        "heat":0
    },
    {
        "code":64,
        "cn":"皮特肯群岛",
        "en":"Pitcairn",
        "py":"PI TE KEN QUN DAO",
        "country":"PN",
        "open":1,
        "heat":85
    },
    {
        "code":351,
        "cn":"葡萄牙",
        "en":"Portugal",
        "py":"PU TAO YA",
        "country":"PT",
        "open":1,
        "countryId":"77",
        "heat":0
    },
    {
        "code":46,
        "cn":"瑞典",
        "en":"Sweden",
        "py":"RUI DIAN",
        "country":"SE",
        "open":1,
        "countryId":"79",
        "heat":0
    },
    {
        "code":41,
        "cn":"瑞士",
        "en":"Switzerland",
        "py":"RUI SHI",
        "country":"CH",
        "open":1,
        "countryId":"80",
        "heat":0
    },
    {
        "code":503,
        "cn":"萨尔瓦多",
        "en":"El Salvador",
        "py":"SA LONG WA DUO",
        "country":"SV",
        "open":1,
        "countryId":"238",
        "heat":0
    },
    {
        "code":381,
        "cn":"塞尔维亚",
        "en":"Serbia",
        "py":"SAI ER WEI YA",
        "country":"RS",
        "open":1,
        "countryId":"183",
        "heat":0
    },
    {
        "code":232,
        "cn":"塞拉利昂",
        "en":"Sierra Leone",
        "py":"SAI LA LI ANG",
        "country":"SL",
        "open":1,
        "countryId":"240",
        "heat":0
    },
    {
        "code":221,
        "cn":"塞内加尔",
        "en":"Senegal",
        "py":"SAI NEI JIA ER",
        "country":"SN",
        "open":1,
        "countryId":"156",
        "heat":0
    },
    {
        "code":357,
        "cn":"塞浦路斯",
        "en":"Cyprus",
        "py":"SAI PU LU SI",
        "country":"CY",
        "open":1,
        "countryId":"81",
        "heat":0
    },
    {
        "code":248,
        "cn":"塞舌尔",
        "en":"Seychelles",
        "py":"SAI SHE ER",
        "country":"SC",
        "open":1,
        "countryId":"174",
        "heat":0
    },
    {
        "code":966,
        "cn":"沙特阿拉伯",
        "en":"Saudi Arabia",
        "py":"SHA TE A LA BO",
        "country":"SA",
        "open":1,
        "countryId":"82",
        "heat":0
    },
    {
        "code":260,
        "cn":"赞比亚",
        "en":"Zambia",
        "py":"ZAN BI YA",
        "country":"ZM",
        "open":1,
        "countryId":"112",
        "heat":0
    },
    {
        "code":590,
        "cn":"圣巴泰勒米",
        "en":"Saint Barthelemy",
        "py":"SHENG BA TAI LE MI",
        "country":"BL",
        "open":1,
        "countryId":"297",
        "heat":0
    },
    {
        "code":239,
        "cn":"圣多美和普林西比",
        "en":"Sao Tome and Principe",
        "py":"SHENG DUO MEI HE PU LIN XI BI",
        "country":"ST",
        "open":1,
        "countryId":"242",
        "heat":0
    },
    {
        "code":1758,
        "cn":"圣卢西亚",
        "en":"Saint Lucia",
        "py":"SHENG LU XI YA",
        "country":"LC",
        "open":1,
        "countryId":"244",
        "heat":0
    },
    {
        "code":590,
        "cn":"圣马丁岛",
        "en":"Saint Martin",
        "py":"SHENG MA DING DAO",
        "country":"MF",
        "open":1,
        "heat":0
    },
    {
        "code":378,
        "cn":"圣马力诺",
        "en":"San Marino",
        "py":"SHENG MA LI NUO",
        "country":"SM",
        "open":1,
        "countryId":"245",
        "heat":0
    },
    {
        "code":508,
        "cn":"圣皮埃尔和密克隆岛",
        "en":"Saint Pierre and Miq",
        "py":"SHENG PI AI ER HE MI KE LONG QUN DAO",
        "country":"PM",
        "open":1,
        "countryId":"289",
        "heat":0
    },
    {
        "code":1784,
        "cn":"圣文森特和格林纳丁斯",
        "en":"Saint Vincent and the Grenadines",
        "py":"SHENG WEN SEN TE DAO",
        "country":"VC",
        "open":1,
        "countryId":"246",
        "heat":0
    },
    {
        "code":94,
        "cn":"斯里兰卡",
        "en":"Sri Lanka",
        "py":"SI LI LAN KA",
        "country":"LK",
        "open":1,
        "countryId":"83",
        "heat":0
    },
    {
        "code":421,
        "cn":"斯洛伐克",
        "en":"Slovakia",
        "py":"SI LUO FA KE",
        "country":"SK",
        "open":1,
        "countryId":"247",
        "heat":0
    },
    {
        "code":386,
        "cn":"斯洛文尼亚",
        "en":"Slovenia",
        "py":"SI LUO WEN NI YA",
        "country":"SI",
        "open":1,
        "countryId":"84",
        "heat":0
    },
    {
        "code":268,
        "cn":"斯威士兰",
        "en":"Swaziland",
        "py":"SI WEI SHI LAN",
        "country":"SZ",
        "open":1,
        "countryId":"196",
        "heat":0
    },
    {
        "code":249,
        "cn":"苏丹",
        "en":"Sudan",
        "py":"SU DAN",
        "country":"SD",
        "open":1,
        "countryId":"85",
        "heat":0
    },
    {
        "code":597,
        "cn":"苏里南",
        "en":"Suriname",
        "py":"SU LI NAN",
        "country":"SR",
        "open":1,
        "countryId":"181",
        "heat":0
    },
    {
        "code":677,
        "cn":"所罗门群岛",
        "en":"Solomon Islands",
        "py":"SUO LUO MEN QUN DAO",
        "country":"SB",
        "open":1,
        "countryId":"248",
        "heat":0
    },
    {
        "code":252,
        "cn":"索马里",
        "en":"Somalia",
        "py":"SUO MA LI",
        "country":"SO",
        "open":1,
        "countryId":"249",
        "heat":0
    },
    {
        "code":992,
        "cn":"塔吉克斯坦",
        "en":"Tajikistan",
        "py":"TA JI KE SI TAN",
        "country":"TJ",
        "open":1,
        "countryId":"250",
        "heat":0
    },
    {
        "code":255,
        "cn":"坦桑尼亚",
        "en":"Tanzania",
        "py":"TAN SANG NI YA",
        "country":"TZ",
        "open":1,
        "countryId":"87",
        "heat":0
    },
    {
        "code":676,
        "cn":"汤加",
        "en":"Tonga",
        "py":"TANG JIA",
        "country":"TO",
        "open":1,
        "countryId":"160",
        "heat":0
    },
    {
        "code":1868,
        "cn":"特立尼达和多巴哥",
        "en":"Trinidad and Tobago",
        "py":"TE LI NI DA HE DUO BA GE",
        "country":"TT",
        "open":1,
        "countryId":"252",
        "heat":0
    },
    {
        "code":216,
        "cn":"突尼斯",
        "en":"Tunisia",
        "py":"TU NI SI",
        "country":"TN",
        "open":1,
        "countryId":"88",
        "heat":0
    },
    {
        "code":688,
        "cn":"图瓦卢",
        "en":"Tuvalu",
        "py":"TU WA LU",
        "country":"TV",
        "open":1,
        "countryId":"253",
        "heat":0
    },
    {
        "code":90,
        "cn":"土耳其",
        "en":"Turkey",
        "py":"TU ER QI",
        "country":"TR",
        "open":1,
        "countryId":"89",
        "heat":0
    },
    {
        "code":993,
        "cn":"土库曼斯坦",
        "en":"Turkmenstan",
        "py":"TU KU MAN SI TAN",
        "country":"TM",
        "open":1,
        "countryId":"195",
        "heat":0
    },
    {
        "code":690,
        "cn":"托克劳群岛",
        "en":"Tokelau",
        "py":"TUO KE LAO QUN DAO",
        "country":"TK",
        "open":1,
        "heat":0
    },
    {
        "code":681,
        "cn":"瓦利斯和富图纳群岛",
        "en":"Wallis And Futuna Is",
        "py":"WA LI SI HE FU SHI NA QUN DAO",
        "country":"WF",
        "open":1,
        "countryId":"286",
        "heat":0
    },
    {
        "code":678,
        "cn":"瓦努阿图",
        "en":"Vanuatu",
        "py":"WA NU A TU",
        "country":"VU",
        "open":1,
        "countryId":"254",
        "heat":0
    },
    {
        "code":502,
        "cn":"危地马拉",
        "en":"Guatemala",
        "py":"WEI DI MA LA",
        "country":"GT",
        "open":1,
        "countryId":"90",
        "heat":0
    },
    {
        "code":58,
        "cn":"委内瑞拉",
        "en":"Venezuela",
        "py":"WEI NEI RUI LA",
        "country":"VE",
        "open":1,
        "countryId":"91",
        "heat":0
    },
    {
        "code":673,
        "cn":"文莱",
        "en":"Brunei",
        "py":"WEN LAI",
        "country":"",
        "open":1,
        "countryId":"92",
        "heat":0
    },
    {
        "code":256,
        "cn":"乌干达",
        "en":"Uganda",
        "py":"WU GAN DA",
        "country":"UG",
        "open":1,
        "countryId":"93",
        "heat":0
    },
    {
        "code":380,
        "cn":"乌克兰",
        "en":"Ukraine",
        "py":"WU KE LAN",
        "country":"UA",
        "open":1,
        "countryId":"119",
        "heat":0
    },
    {
        "code":598,
        "cn":"乌拉圭",
        "en":"Uruguay",
        "py":"WU LA GUI",
        "country":"UY",
        "open":1,
        "countryId":"94",
        "heat":0
    },
    {
        "code":998,
        "cn":"乌兹别克斯坦",
        "en":"Uzbekistan",
        "py":"WU ZI BIE KE SI TAN",
        "country":"UZ",
        "open":1,
        "countryId":"144",
        "heat":0
    },
    {
        "code":34,
        "cn":"西班牙",
        "en":"Spain",
        "py":"XI BAN YA",
        "country":"ES",
        "open":1,
        "countryId":"95",
        "heat":0
    },
    {
        "code":212,
        "cn":"西撒哈拉国",
        "en":"Western Sahara",
        "py":"XI SA HA LA GUO",
        "country":"EH",
        "open":1,
        "heat":0
    },
    {
        "code":685,
        "cn":"西萨摩亚",
        "en":"Samoa Western",
        "py":"XI SA MO YA",
        "country":"",
        "open":1,
        "heat":0
    },
    {
        "code":30,
        "cn":"希腊",
        "en":"Greece",
        "py":"XI LA ",
        "country":"GR",
        "open":1,
        "countryId":"96",
        "heat":0
    },
    {
        "code":687,
        "cn":"新喀里多尼亚",
        "en":"New Caledonia",
        "py":"XIN KA LI DUO NI YA",
        "country":"NC",
        "open":1,
        "countryId":"263",
        "heat":0
    },
    {
        "code":36,
        "cn":"匈牙利",
        "en":"Hungary",
        "py":"XIONG YA LI ",
        "country":"HU",
        "open":1,
        "countryId":"99",
        "heat":0
    },
    {
        "code":963,
        "cn":"叙利亚",
        "en":"Syria",
        "py":"XU LI YA",
        "country":"SY",
        "open":1,
        "countryId":"100",
        "heat":0
    },
    {
        "code":1876,
        "cn":"牙买加",
        "en":"Jamaica",
        "py":"YA MAI JIA",
        "country":"JM",
        "open":1,
        "countryId":"101",
        "heat":0
    },
    {
        "code":374,
        "cn":"亚美尼亚",
        "en":"Armenia",
        "py":"YA MEI NI YA",
        "country":"AM",
        "open":1,
        "countryId":"175",
        "heat":0
    },
    {
        "code":967,
        "cn":"也门",
        "en":"Yemen",
        "py":"YE MEN",
        "country":"YE",
        "open":1,
        "countryId":"102",
        "heat":0
    },
    {
        "code":964,
        "cn":"伊拉克",
        "en":"Iraq",
        "py":"YI LA KE",
        "country":"IQ",
        "open":1,
        "countryId":"103",
        "heat":0
    },
    {
        "code":98,
        "cn":"伊朗",
        "en":"Iran",
        "py":"YI LANG",
        "country":"IR",
        "open":1,
        "countryId":"104",
        "heat":0
    },
    {
        "code":972,
        "cn":"以色列",
        "en":"Israel",
        "py":"YI SE LIE",
        "country":"IL",
        "open":1,
        "countryId":"105",
        "heat":0
    },
    {
        "code":962,
        "cn":"约旦",
        "en":"Jordan",
        "py":"YUE DAN ",
        "country":"JO",
        "open":1,
        "countryId":"110",
        "heat":0
    },
    {
        "code":243,
        "cn":"扎伊尔",
        "en":"Zaire",
        "py":"ZHA YI ER",
        "country":"ZR",
        "open":1,
        "heat":0
    },
    {
        "code":235,
        "cn":"乍得",
        "en":"Chad",
        "py":"ZHA DE",
        "country":"TD",
        "open":1,
        "countryId":"114",
        "heat":0
    },
    {
        "code":350,
        "cn":"直布罗陀",
        "en":"Gibraltar",
        "py":"ZHI BU LUO TUO ",
        "country":"GI",
        "open":1,
        "countryId":"287",
        "heat":0
    },
    {
        "code":56,
        "cn":"智利",
        "en":"Chile",
        "py":"ZHI LI",
        "country":"CL",
        "open":1,
        "countryId":"115",
        "heat":0
    },
    {
        "code":1869,
        "cn":"圣基茨和尼维斯",
        "en":"The Federation of Saint Kitts and Nevis",
        "py":"SHENG JI CI HE NI WEI SI",
        "country":"KN",
        "open":1,
        "countryId":"115",
        "heat":0
    },
    {
        "code":236,
        "cn":"中非共和国",
        "en":"Central Africa Republic",
        "py":"ZHONG FEI GONG HE GUO",
        "country":"CF",
        "open":1,
        "countryId":"256",
        "heat":0
    }
]
